export default __webpack_public_path__ + "static/media/information--disabled-persons--g2.43579fe3.png";